import { render, staticRenderFns } from "./VMenuItem.vue?vue&type=template&id=840f70be&"
import script from "./VMenuItem.vue?vue&type=script&lang=js&"
export * from "./VMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports